import React from 'react'
import styled from 'styled-components'
import { Box, Button, get, TextHeading } from '@ally/metronome-ui'
import { AccountDetails } from '../../../types'
import { NonPrintingWrapper } from '../../../utils/NonPrintingWrapper'

interface AccountDetailsProps {
  account: AccountDetails
  setIsEdit: (edit: boolean) => void
  setIsDetailsCardError: (isError: boolean) => void
  editButtonRef: React.Ref<HTMLButtonElement>
}

const AcctName = styled(Box)`
  display: flex;
  align-items: flex-end;
`

const StyledEditNickname = styled(Box)`
  display: inline;
  padding-left: ${get.space('xs')};
`

const NicknameTitle = styled(TextHeading)`
  display: inline;
`

export const AcctNickname: React.FC<AccountDetailsProps> = ({
  account,
  setIsEdit,
  setIsDetailsCardError,
  editButtonRef,
}) => {
  const handleOpenForm = (): void => {
    setIsDetailsCardError(false)
    setIsEdit(true)
  }
  return (
    <AcctName>
      <NicknameTitle tag="h1" size="md" weight="normal">
        {account.accountNickname}
      </NicknameTitle>
      {account.accountStatus !== 'Closed' && (
        <StyledEditNickname>
          <NonPrintingWrapper>
            <Button
              variant="link"
              text="Edit Nickname"
              id="editNicknameButton"
              onClick={handleOpenForm}
              ref={editButtonRef}
              withAllyTM="editNickname"
            />
          </NonPrintingWrapper>
        </StyledEditNickname>
      )}
    </AcctName>
  )
}
